import img10 from "../assets/Logo/Logo/images-2.png";
import img13 from "../assets/Logo/Logo/images-3.png";
import img12 from "../assets/Logo/Logo/images-4.jpeg";
import img from "../assets/Logo/Logo/img.png";
import img0 from "../assets/Logo/Logo/img0.jpeg";
import img1 from "../assets/Logo/Logo/img1.jpg";
import img2 from "../assets/Logo/Logo/img2.png";
import img3 from "../assets/Logo/Logo/img3.png";
import img4 from "../assets/Logo/Logo/img4.png";
import img5 from "../assets/Logo/Logo/img5.png";
import img6 from "../assets/Logo/Logo/img6.png";
import img7 from "../assets/Logo/Logo/img7.png";
import img8 from "../assets/Logo/Logo/img8.png";
import img9 from "../assets/Logo/Logo/img9.png";

const clients = [
  { id: 2, name: "RT Alkin 1", logo: img },
  { id: 3, name: "Bayview Construction", logo: img0 },
  { id: 4, name: "RT Alkin 2", logo: img1 },
  { id: 6, name: "Complet Home 1", logo: img2 },
  { id: 7, name: "Complet Home 2", logo: img3 },
  { id: 8, name: "Complet Home 3", logo: img4 },
  { id: 9, name: "Complet Home 4", logo: img5 },
  { id: 10, name: "Complet Home 5", logo: img6 },
  { id: 11, name: "Complet Home 6", logo: img7 },
  { id: 12, name: "Complet Home 7", logo: img8 },
  { id: 13, name: "Complet Home 8", logo: img9 },
  { id: 14, name: "Complet Home 9", logo: img10 },
  { id: 16, name: "Complet Home 11", logo: img12 },
  { id: 17, name: "Complet Home 12", logo: img13 },
];

const ClientsPartners = () => {
  return (
    <section className="w-full py-20 mb-10 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Heading */}
        <div className="mb-10 text-center">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800">
            Some Of Our Valuable <span className="text-primary">Clients</span>
          </h3>
          <p className="mt-2 text-gray-500">
            Trust us to provide innovative solutions and outstanding service,
            helping your businesses grow and succeed.
          </p>
        </div>

        {/* Auto-scrolling logos */}
        <div className="overflow-hidden relative w-full">
          <div className="flex gap-8 animate-scroll">
            {clients.concat(clients).map((client, idx) => (
              <div
                key={idx}
                className="flex items-center justify-center p-4 bg-white shadow rounded-lg border min-w-[150px]"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  loading="lazy"
                  className="max-h-16 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsPartners;
